(function () {
  var api = window.BelfaAnalytics;
  if (!api || window.__belfaNativeLeads) return;
  window.__belfaNativeLeads = true;
  var script = document.currentScript;
  var successContexts = Object.create(null);
  var reportedSuccesses = Object.create(null);
  var formStorageKey = 'belfa_form_attempts_v1';
  var authStorageKey = 'belfa_auth_attempt_v1';

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  }

  function storageRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) {}
  }

  function attempts() {
    try {
      var stored = JSON.parse(storageGet(formStorageKey) || '[]');
      return Array.isArray(stored) ? stored.filter(function (item) { return item && typeof item.created === 'number' && Date.now() - item.created < 1800000; }).slice(-5) : [];
    } catch (error) { return []; }
  }

  function formKind(form) {
    var type = form.querySelector('input[name="form_type"]');
    if (!type) return null;
    if (type.value === 'contact') return 'contact';
    var tags = form.querySelector('input[name="contact[tags]"]');
    return type.value === 'customer' && tags && /newsletter|prospect/.test(tags.value) ? 'newsletter' : null;
  }

  function successContext(marker, kind) {
    if (successContexts[kind]) return successContexts[kind];
    var form = marker.closest('form');
    var id = form && form.id || kind;
    var stored = attempts();
    for (var i = stored.length - 1; i >= 0; i--) {
      var item = stored[i];
      if (item.kind !== kind) continue;
      try {
        if (new URL(item.url).origin !== window.location.origin) continue;
        return successContexts[kind] = { key: String(item.created), url: item.url, form: item.form };
      } catch (error) {}
    }
    return successContexts[kind] = { key: window.location.pathname + window.location.search + ':' + kind, url: window.location.href, form: id };
  }

  function restoreAuth() {
    if (!api.analyticsAllowed() || !script || script.dataset.authenticated !== 'true') return;
    try {
      var item = JSON.parse(storageGet(authStorageKey) || 'null');
      if (!item || (item.name !== 'login' && item.name !== 'sign_up') || typeof item.created !== 'number' || Date.now() - item.created > 900000) return;
      if (new URL(item.url).origin !== window.location.origin) return;
      storageRemove(authStorageKey);
      api.track(item.name, { method: 'shopify_native', page_location: item.url }, 'belfa_auth_' + item.name + '_' + item.created);
    } catch (error) {}
  }

  function scanSuccess() {
    document.querySelectorAll('[data-belfa-lead-success]').forEach(function (marker) {
      var kind = marker.dataset.belfaLeadSuccess;
      if (kind !== 'contact' && kind !== 'newsletter') return;
      var context = successContext(marker, kind);
      var key = kind + '_' + context.key;
      if (reportedSuccesses[key]) return;
      reportedSuccesses[key] = true;
      if (kind === 'contact') api.track('contact_form_submitted', { page_location: context.url }, 'belfa_cfs_' + window.location.pathname + window.location.search);
      api.trackAdsLead(kind, context.url, 'belfa_ads_lead_' + kind + '_' + context.key);
    });
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true' && !reportedSuccesses.contactRedirect) {
      reportedSuccesses.contactRedirect = true;
      api.track('contact_form_submitted', { page_location: window.location.href }, 'belfa_cfs_' + window.location.pathname + window.location.search);
    }
    restoreAuth();
    api.flush();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.nodeName !== 'FORM') return;
    var type = form.querySelector('input[name="form_type"]');
    if (type && (type.value === 'customer_login' || type.value === 'create_customer') && api.analyticsAllowed()) {
      storageSet(authStorageKey, JSON.stringify({ name: type.value === 'customer_login' ? 'login' : 'sign_up', created: Date.now(), url: window.location.href }));
    }
    var kind = formKind(form);
    if (!kind || (!api.analyticsAllowed() && !api.marketingAllowed())) return;
    var stored = attempts();
    stored.push({ kind: kind, form: form.id || kind, path: window.location.pathname, created: Date.now(), url: window.location.href });
    storageSet(formStorageKey, JSON.stringify(stored.slice(-5)));
  }, true);

  document.addEventListener('visitorConsentCollected', scanSuccess);
  window.addEventListener('belfa:privacy-ready', scanSuccess);
  window.addEventListener('pageshow', scanSuccess);
  window.addEventListener('load', scanSuccess, { once: true });
  window.addEventListener('focus', restoreAuth);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanSuccess, { once: true });
  else scanSuccess();
})();
